import script from "./previewVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./previewVideo.vue?vue&type=script&lang=ts&setup=true"

import "./previewVideo.vue?vue&type=style&index=0&id=32b23046&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b23046"]])

export default __exports__